import { useState, useEffect, useRef } from "react";

import "./DashboardVariable.css";
import TextInput from '/src/components/UI/TextField/TextInput';
import { checkNumber } from "../../../checkNumber";
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';

function DashboardNumber({ data, postbackAction }) {
    data.value = parseInt(data.value)
    const toast = useToastDispatchContext();
    const [error, setError] = useState(false)
    const [typingTimer, setTypingTimer] = useState(null);
    const inputRef = useRef();

    const checkError = (val) => {
        let bool = val.length == 0
        setError(bool)
        return bool;
    }

    const modifyValue = (nb) => {
        saveData(nb, checkError(nb))
    }
    const saveData = (text, err) => {
        clearTimeout(typingTimer);
        setTypingTimer(setTimeout(() => {
            if (err) {
                inputRef.current.value = data.value;
                setError(false)
                toast.success('Variable\'s value reinitialized', 'The value of the variable " ' + data.label + ' " has been reinitialized because the last one didn\'t match with the wished structure !',5000);
            }
            else {
                postbackAction(text);
            }
        }, 1500));
    }

    return (
        <div className="dashboard_text_area" key={data.id}>
            <TextInput ref={inputRef} type="number" onKeyDown={(e) => checkNumber(e)} style={{border: error? "2px solid red" : ""}}defaultValue={data.value} className={"input_number_variable_dashboard"} onChange={(e) => modifyValue(e.target.value)} />
            {
                error &&
                <div className="error_message">
                    The value has to be a number
                </div>
            }

        </div>
    );
}

export default DashboardNumber;